import { Templates, utils, Components } from 'zero';
import InputButton from './InputButton';

const { Edit } = Templates;
const { Toaster } = Components;
const editItemList = [{
  key: 'channelBankId',
  text: '银行渠道',
  type: 'select',
  options: [{
    value: '', text: '请选择'
  }, {
    value: 'jingu', text: '金谷农商行'
  }],
  valid: 'required',
  errorMsg: '请选择银行渠道',
}, {
  key: 'loanProductType',
  text: '贷款产品类型',
  type: 'select',
  options: [{
    value: '', text: '请选择'
  }, {
    value: '01', text: '个人小额信贷'
  }],
  valid: 'required',
  errorMsg: '请选择贷款产品类型',
}, {
  key: 'loanProductName',
  text: '贷款产品名称',
  valid: 'required',
  errorMsg: '请输入贷款产品名称',
}, {
  key: 'loanProductDescription',
  text: '贷款产品描述',
  type: 'textarea',
  value: '',
  valid: 'required',
  maxLength: 200,
  errorMsg: '请输入贷款产品描述',
}, {
  key: 'repaymentMethod',
  text: '还款方式',
  type: 'select',
  options: [{
    value: '', text: '请选择'
  }, {
    value: '01', text: '等额本息'
  }],
  valid: 'required',
  errorMsg: '请选择还款方式',
}, {
  key: 'loanProductTermType',
  text: '产品期限类型',
  type: 'select',
  options: [{
    value: '', text: '请选择'
  }, {
    value: '01', text: '固定期限'
  }],
  valid: 'required',
  errorMsg: '请选择产品期限类型',
  changeParams: ['fixedLoanProductTerm'],
  change: (val, $$dom) => {
    if (val === '01') {
      $$dom.style.display = 'block';
    } else {
      $$dom.style.display = 'none';
    }
  },
}, {
  key: 'termUnit',
  text: '期限单位',
  type: 'select',
  options: [{
    value: '', text: '请选择'
  }, {
    value: 1, text: '月'
  }],
  valid: 'required',
  errorMsg: '请选择期限单位',
}, {
  key: 'fixedLoanProductTerm',
  text: '固定产品期限',
  placeholder: '请输入1~1000之间的整数',
  min: 1,
  max: 1000,
  maxLengthShow: false,
  typeStyle: 'overHalf',
  type: 'dynamic',
  WrappedComponent: InputButton,
  conditionValid: true,
  model: 'mix',
  valid: 'commaArray',
  inputValid: 'number',
  inputType: 'number',
  errorMsg: '请输入固定产品期限',
  isShow: v => v === '01',
  isShowParams: ['loanProductTermType']
}, {
  key: 'loanInterestRateType',
  text: '贷款利率类型',
  type: 'select',
  options: [{
    value: '', text: '请选择'
  }, {
    value: 1, text: '固定'
  }, {
    value: 2, text: '浮动'
  }],
  changeParams: ['fixedLoanInterestMonthRate', 'floatLoanInterestMonthRate'],
  change: (val, $$fix, $$float) => {
    if (val === '1') {
      $$float.style.display = 'none';
      $$fix.style.display = 'block';
    } else if (val === '2') {
      $$fix.style.display = 'none';
      $$float.style.display = 'block';
    } else {
      $$fix.style.display = 'none';
      $$float.style.display = 'none';
    }
  },
  valid: 'required',
  errorMsg: '请选择贷款利率类型',
}, {
  key: 'fixedLoanInterestMonthRate',
  text: '固定贷款月利率',
  value: '',
  type: 'number',
  after: '%',
  valid: 'percent',
  conditionValid: true,
  isShow: v => v === '1',
  isShowParams: ['loanInterestRateType'],
}, {
  key: 'floatLoanInterestMonthRate',
  text: '浮动贷款月利率',
  items: [{
    key: 'minFloatLoanInterestMonthRate',
    type: 'number',
    after: '%（最小利率） -',
    valid: 'percent',
    typeStyle: 'half'
  }, {
    style: {
      marginLeft: 10
    },
    key: 'maxFloatLoanInterestMonthRate',
    type: 'number',
    after: '%（最大利率）',
    valid: 'percent',
    typeStyle: 'half'
  }],
  valid: (min, max) => +min <= +max,
  conditionValid: true,
  errorMsg: '最小利率不得大于最大利率',
  isShow: v => v === '2',
  isShowParams: ['loanInterestRateType'],
}, {
  key: 'effectDayType',
  text: '起息条件类型',
  type: 'select',
  value: '',
  options: [{
    text: '请选择', value: ''
  }, {
    text: '放款成功', value: '1'
  }, {
    text: '签约成功', value: '2'
  }],
  valid: 'required',
  errorMsg: '请选择起息条件类型',
}, {
  key: 'effectDay',
  text: '起息日',
  value: '',
  type: 'select',
  options: [{
    text: '请选择', value: ''
  }].concat(
    utils.array.from({ length: 11 }, (a, b) => b)
    .map(i => ({ text: i, value: i }))
  ),
  valid: 'required',
  errorMsg: '请选择起息日',
}, {
  key: 'openLoanTime',
  text: '起始放贷时间',
  type: 'date',
  dateFormat: 'YYYY-MM-DD HH:mm'
}, {
  key: 'closeLoanTime',
  text: '结束放贷时间',
  type: 'date',
  dateFormat: 'YYYY-MM-DD hh:mm'
}, {
  key: 'quotaType',
  text: '配额类型',
  type: 'select',
  value: '',
  options: [{
    text: '请选择', value: ''
  }, {
    text: '不限额', value: '01'
  }, {
    text: '固定限额', value: '02'
  }, {
    text: '自动同步配额', value: '03'
  }],
  valid: 'required',
  errorMsg: '请选择配额类型',
  changeParams: ['totalQuota', 'dayQuota'],
  change: (val, $$dom, $$dom2) => {
    if (val === '02') {
      $$dom.style.display = 'block';
      $$dom2.style.display = 'block';
    } else {
      $$dom.style.display = 'none';
      $$dom2.style.display = 'none';
    }
  },
}, {
  key: 'totalQuota',
  text: '产品总配额',
  type: 'number',
  after: '万',
  min: 1,
  max: 99999,
  valid: 'number',
  conditionValid: true,
  isShow: v => v === '02',
  isShowParams: ['quotaType'],
}, {
  key: 'dayQuota',
  text: '产品日配额',
  type: 'number',
  after: '万',
  min: 1,
  max: 99999,
  valid: 'number',
  isShow: v => v === '02',
  isShowParams: ['quotaType'],
}, {
  key: 'fundSourceType',
  text: '贷款资金来源渠道',
  type: 'select',
  value: '',
  options: [{
    text: '请选择', value: ''
  }, {
    text: '方付通', value: '01'
  }, {
    text: '渠道银行', value: '02'
  }, {
    text: '混合', value: '03'
  }]
}, {
  key: 'minLoanAmount',
  text: '最小贷款金额',
  type: 'number',
  value: '1',
  min: 1,
  max: 1000000,
  valid: 'number',
}, {
  key: 'maxLoanAmount',
  text: '最大贷款金额',
  value: '1000000',
  type: 'number',
  min: 1,
  max: 1000000,
  valid: 'number',
}, {
  key: 'loanFeeType',
  text: '借款服务费类型',
  value: '00',
  type: 'select',
  options: [{
    text: '不收取', value: '00'
  }, {
    text: '服务费前置放款扣除', value: '01'
  }, {
    text: '服务费按月均分', value: '02'
  }, {
    text: '服务费到期一次性收取', value: '03'
  }],
  changeParams: ['loanFeeRate'],
  change: (val, $$dom) => {
    if (val === '00') {
      $$dom.style.display = 'none';
    } else {
      $$dom.style.display = 'block';
    }
  },
}, {
  key: 'loanFeeRate',
  text: '借款服务费率',
  value: '0',
  type: 'number',
  after: '%',
  valid: 'percent',
  isShow: v => v !== '00',
  isShowParams: ['loanFeeType']
}, {
  key: 'lateChargeFreeDays',
  text: '逾期免息期限',
  value: '0',
  type: 'number',
  valid: 'number',
  after: '天',
  min: 0,
  max: 365,
}, {
  key: 'lateChargeRateType',
  text: '逾期罚息类型',
  value: '01',
  type: 'select',
  options: [{
    text: '固定罚息利率当期未还金额按天计算', value: '01'
  }],
  changeParams: ['fixedLateChargeRate', 'floatLateChargeRate'],
  change: (val, $$fix, $$float) => {
    if (val === '01') {
      $$float.style.display = 'none';
      $$fix.style.display = 'block';
    } else if (val === '02') {
      $$fix.style.display = 'none';
      $$float.style.display = 'block';
    } else {
      $$fix.style.display = 'none';
      $$float.style.display = 'none';
    }
  },
}, {
  key: 'fixedLateChargeRate',
  text: '逾期固定罚息费率',
  value: '0',
  type: 'number',
  after: '%/天',
  valid: 'percent',
  conditionValid: true,
  isShow: v => v === '01',
  isShowParams: ['lateChargeRateType'],
}, {
  key: 'floatLateChargeRate',
  text: '逾期浮动罚息费率',
  items: [{
    key: 'baseFloatLateChargeRate',
    text: '基础罚息利率',
    type: 'number',
    after: '%/天',
    value: '0',
    valid: 'percent',
  }, {
    key: 'progressiveFloatLateChargeRate',
    text: '每日递进利率',
    type: 'number',
    after: '%/天',
    value: '0',
    textStyle: {
      marginLeft: 20
    },
    valid: 'percent',
  }],
  valid: (min, max) => +min <= +max,
  conditionValid: true,
  errorMsg: '基础罚息利率不得大于每日递进利率',
  isShow: v => v === '02',
  isShowParams: ['lateChargeRateType'],
}, {
  key: 'remark',
  text: '备注',
  type: 'textarea',
  maxLength: 256,
}];

const valid = [{
  func: (a, b) => (a !== '01' || b !== ''),
  params: ['loanProductTermType', 'fixedLoanProductTerm'],
  errorMsg: '产品期限类型选择“固定期限”时固定产品期限必填'
}, {
  func: (a, b) => (a !== '1' || b !== ''),
  params: ['loanInterestRateType', 'fixedLoanInterestMonthRate'],
  errorMsg: '贷款利率类型选择“固定”时固定贷款利率必填'
}, {
  func: (a, b, c) => (a !== '2' || b !== '' || c !== ''),
  params: ['loanInterestRateType', 'minFloatLoanInterestMonthRate', 'maxFloatLoanInterestMonthRate'],
  errorMsg: '贷款利率类型选择“浮动”时固定贷款利率必填'
}, {
  func: (a, b) => (a !== '02' || b !== ''),
  params: ['quotaType', 'totalQuota'],
  errorMsg: '配额类型为“固定限额”时产品总配额必填'
}, {
  func: (a, b) => (a !== '01' || b !== ''),
  params: ['lateChargeRateType', 'fixedLateChargeRate'],
  errorMsg: '逾期罚息类型为“固定罚息利率当期未还金额按天计算”时逾期固定罚息费率必填'
}, {
  func: (a, b, c) => (a !== '02' || b !== '' || c !== ''),
  params: ['lateChargeRateType', 'baseFloatLateChargeRate', 'progressiveFloatLateChargeRate'],
  errorMsg: '逾期罚息类型为“递进罚息未还金额按天计算”时逾期浮动罚息费率'
}, {
  func: (a, b) => { if (a && b) { return (a < b); } return true; },
  params: ['openLoanTime', 'closeLoanTime'],
  errorMsg: '起始放贷时间不得大于结束放贷时间'
}, {
  func: (a, b) => { if (a && b) { return (a <= b); } return true; },
  params: ['dayQuota', 'totalQuota'],
  errorMsg: '产品日配额不得大于产品总配额'
}, {
  func: (a, b) => { if (a && b) { return (a <= b); } return true; },
  params: ['minLoanAmount', 'maxLoanAmount'],
  errorMsg: '最大贷款金额不得小于最小贷款金额'
}];

const titlepart = {
  title: '信贷产品新增',
  note: '打*为必选'
};
function save(cdata) {
  const option = {
    method: 'POST',
    data: cdata,
    headers: {
      token: localStorage.getItem('token'),
      userId: localStorage.getItem('userId')
    }
  };
  utils.fetch('/api/bosscredit/product/add', option).then((res) => {
    Toaster.toaster({ type: 'success', content: '保存成功', time: 3000 });
    const id = res.data.loanProductId;
    window.location.href = `./creditProductDetail.html?id=${id}`;
  }, (error) => {
    Toaster.toaster({ type: 'error', content: (error && error.message) || '保存出错', time: 3000 });
  });
}

utils.fetch('/api/bosscredit/product/id', {
  method: 'GET',
  data: {
    loanProductId: utils.getUrlParam().id
  },
  headers: {
    token: localStorage.getItem('token'),
    userId: localStorage.getItem('userId')
  }
}).then((res) => {
  Edit({
    editItemList,
    valid,
    save,
    titlepart,
    respData: res.data,
  });
}, (error) => {
  Toaster.toaster({ type: 'error', content: (error && error.message) || '获取数据错误', time: 3000 });
});



// WEBPACK FOOTER //
// ./example/src/page/creditProductEdit/index.js